// 交易所初筛问卷枚举类型定义
// 基于 docs/问卷/交易所初筛问卷设计.md

export enum EnterpriseType {
  CENTRAL_SOE = 'central_soe', // 中央企业
  LOCAL_SOE = 'local_soe', // 地方国有企业
  LISTED_COMPANY = 'listed_company', // 上市公司
  PRIVATE_ENTERPRISE = 'private_enterprise', // 民营企业
  FOREIGN_ENTERPRISE = 'foreign_enterprise', // 外资企业
  OTHER = 'other', // 其他
}

export enum RegistrationType {
  MAINLAND_CHINA = 'mainland_china', // 中国大陆
  HONG_KONG = 'hong_kong', // 香港
  MACAU = 'macau', // 澳门
  OTHER_OVERSEAS = 'other_overseas', // 其他境外地区
}

export enum CreditRating {
  AAA = 'AAA',
  AA_PLUS = 'AA+',
  AA = 'AA',
  AA_MINUS = 'AA-',
  A_PLUS_AND_BELOW = 'A+_and_below',
  NO_RATING = 'no_rating',
}

export enum InternationalRating {
  INVESTMENT_GRADE = 'investment_grade', // 投资级
  NON_INVESTMENT_GRADE = 'non_investment_grade', // 非投资级
  NO_INTERNATIONAL_RATING = 'no_international_rating', // 暂无国际评级
}

export enum AssetScale {
  ABOVE_100B = 'above_100b', // 1000亿元以上
  FROM_50B_TO_100B = '50b_to_100b', // 500-1000亿元
  FROM_20B_TO_50B = '20b_to_50b', // 200-500亿元
  FROM_10B_TO_20B = '10b_to_20b', // 100-200亿元
  FROM_5B_TO_10B = '5b_to_10b', // 50-100亿元
  BELOW_5B = 'below_5b', // 50亿元以下
}

// 原有Industry枚举已移动到文件末尾，使用新的定义

// 原有DebtRatio枚举已移动到文件末尾，使用新的定义

// 原有ProfitScale枚举已移动到文件末尾，使用新的定义

// 原有CashFlowStatus枚举已移动到文件末尾，使用新的定义

export enum DefaultRecord {
  NO_DEFAULT = 'no_default', // 无任何违约记录
  MINOR_RESOLVED = 'minor_resolved', // 轻微逾期已解决
  DEFAULT_RESTRUCTURED = 'default_restructured', // 违约已重组
  CURRENT_DEFAULT = 'current_default', // 目前存在违约
}

// 原有GreenProjectStatus枚举已移动到文件末尾，使用新的定义

export enum GreenProjectCategory {
  RENEWABLE_ENERGY = 'renewable_energy', // 可再生能源
  ENERGY_SAVING = 'energy_saving', // 节能减排
  ENVIRONMENTAL_TREATMENT = 'environmental_treatment', // 环境治理
  CLEAN_TRANSPORTATION = 'clean_transportation', // 清洁交通
  GREEN_BUILDING = 'green_building', // 绿色建筑
  CIRCULAR_ECONOMY = 'circular_economy', // 循环经济
  ECOLOGICAL_PROTECTION = 'ecological_protection', // 生态保护
  OTHER_GREEN = 'other_green', // 其他绿色项目
}

export enum GreenStandardCompliance {
  CERTIFIED = 'certified', // 已获得权威机构绿色认证
  PBOC_COMPLIANT = 'pboc_compliant', // 符合央行绿色金融目录
  INTERNATIONAL_COMPLIANT = 'international_compliant', // 符合国际绿色标准
  BASICALLY_COMPLIANT = 'basically_compliant', // 基本符合需确认
  UNCERTAIN = 'uncertain', // 不确定是否符合
}

export enum QuestionnaireStatus {
  DRAFT = 'draft', // 草稿
  SUBMITTED = 'submitted', // 已提交
  UNDER_REVIEW = 'under_review', // 审核中
  APPROVED = 'approved', // 已通过
  REJECTED = 'rejected', // 已拒绝
  NEED_SUPPLEMENT = 'need_supplement', // 需要补充
}

export enum ScreeningDecision {
  AUTO_PASS = 'auto_pass', // 自动通过
  PRIORITY_REVIEW = 'priority_review', // 重点关注
  CONDITIONAL_PASS = 'conditional_pass', // 需要补强
  NOT_PASS = 'not_pass', // 暂不通过
}

// 缺少的枚举类型
export enum InvestmentScale {
  ABOVE_10B = 'above_10b', // 100亿元以上
  FROM_5B_TO_10B = '5b_to_10b', // 50-100亿元
  FROM_1B_TO_5B = '1b_to_5b', // 10-50亿元
  FROM_500M_TO_1B = '500m_to_1b', // 5-10亿元
  BELOW_500M = 'below_500m', // 5亿元以下
}

export enum IssuanceScale {
  ABOVE_5B = 'above_5b', // 50亿元以上
  FROM_3B_TO_5B = '3b_to_5b', // 30-50亿元
  FROM_1B_TO_3B = '1b_to_3b', // 10-30亿元
  FROM_500M_TO_1B = '500m_to_1b', // 5-10亿元
  BELOW_500M = 'below_500m', // 5亿元以下
}

export enum IssuanceTime {
  WITHIN_3_MONTHS = 'within_3_months', // 3个月内
  WITHIN_6_MONTHS = 'within_6_months', // 6个月内
  WITHIN_1_YEAR = 'within_1_year', // 1年内
  OVER_1_YEAR = 'over_1_year', // 1年以上
  UNCERTAIN = 'uncertain', // 尚不确定
}

export enum ProductType {
  GREEN_BOND = 'green_bond', // 绿色债券
  SUSTAINABILITY_BOND = 'sustainability_bond', // 可持续发展债券
  TRANSITION_BOND = 'transition_bond', // 转型债券
  BLUE_BOND = 'blue_bond', // 蓝色债券
  OTHER = 'other', // 其他
}

export enum TargetMarket {
  DOMESTIC = 'domestic', // 境内市场
  OVERSEAS = 'overseas', // 境外市场
  BOTH = 'both', // 两个市场均可
  UNDECIDED = 'undecided', // 尚未确定
}

export enum LitigationStatus {
  NO_LITIGATION = 'no_litigation', // 无重大诉讼或仲裁
  MINOR_LITIGATION = 'minor_litigation', // 有轻微诉讼已解决
  ONGOING_LITIGATION = 'ongoing_litigation', // 有正在进行的诉讼
  MAJOR_LITIGATION = 'major_litigation', // 有重大诉讼风险
}

export enum EnvironmentalCompliance {
  FULLY_COMPLIANT = 'fully_compliant', // 完全合规
  MINOR_ISSUES = 'minor_issues', // 轻微问题已整改
  UNDER_RECTIFICATION = 'under_rectification', // 正在整改中
  SERIOUS_VIOLATIONS = 'serious_violations', // 存在严重违规
}

export enum RegulatoryApproval {
  APPROVED = 'approved', // 已获得批准
  IN_PROGRESS = 'in_progress', // 正在申请中
  NOT_REQUIRED = 'not_required', // 不需要特殊批准
  UNCERTAIN = 'uncertain', // 不确定是否需要
}

export enum UrgencyLevel {
  HIGH = 'high', // 高
  MEDIUM = 'medium', // 中
  LOW = 'low', // 低
}

// 修正的枚举类型
export enum Industry {
  ENERGY = 'energy', // 能源
  INFRASTRUCTURE = 'infrastructure', // 基础设施
  FINANCIAL_SERVICES = 'financial_services', // 金融服务
  REAL_ESTATE = 'real_estate', // 房地产
  MANUFACTURING = 'manufacturing', // 制造业
  CONSUMER_SERVICES = 'consumer_services', // 消费服务
  TECHNOLOGY = 'technology', // 科技
  OTHER = 'other', // 其他
}

export enum DebtRatio {
  BELOW_60 = 'below_60', // 60%以下
  FROM_60_TO_70 = '60_to_70', // 60%-70%
  FROM_70_TO_80 = '70_to_80', // 70%-80%
  ABOVE_80 = 'above_80', // 80%以上
  UNKNOWN = 'unknown', // 不清楚
}

export enum ProfitScale {
  ABOVE_1B = 'above_1b', // 10亿元以上
  FROM_500M_TO_1B = '500m_to_1b', // 5-10亿元
  FROM_100M_TO_500M = '100m_to_500m', // 1-5亿元
  FROM_0_TO_100M = '0_to_100m', // 0-1亿元
  LOSS = 'loss', // 亏损
}

export enum CashFlowStatus {
  EXCELLENT = 'excellent', // 优秀
  GOOD = 'good', // 良好
  FAIR = 'fair', // 一般
  POOR = 'poor', // 较差
  UNKNOWN = 'unknown', // 不清楚
}

export enum GreenProjectStatus {
  CLEAR_PROJECT = 'clear_project', // 有明确项目
  IN_PLANNING = 'in_planning', // 规划中
  NO_CLEAR_PROJECT = 'no_clear_project', // 无明确项目
}
